/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import './checkbox.css'

import PropTypes from 'prop-types'
import React from 'react'

const Checkbox = ({ checked, isChecked, onChange }) => (
  <label
    className="checkbox"
    onClick={event => {
      event.stopPropagation()
      event.preventDefault()

      onChange(!isChecked, event)
    }}
  >
    <input className="cursor-pointer" checked={checked} type="checkbox" defaultChecked={isChecked} />
    <span className="fake-checkbox cursor-pointer" />
  </label>
)

Checkbox.defaultProps = {
  onChange: () => {},
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
}

export default Checkbox
